import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const OHSApi = createApi({
  reducerPath: "OHSApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["OHSApi"],
  endpoints: (build) => ({
    getAllOhsCounts: build.mutation({
      query: ({ id }) => ({
        url: `/index.php?VALUE=ohmscount`,
        method: "POST",
        body: { id: id },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["OHSApi"],
    }),

    //     getTeacherById: build.query({
    //       query: ({ id }) => ({
    //         url: `/teachers/${id}`,
    //         method: "GET",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       providesTags: ["OHSApi"],
    //     }),

    //     editTeacher: build.mutation({
    //       query: ({ id, data }) => ({
    //         url: `/teachers/${id}`,
    //         method: "PUT",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["OHSApi"],
    //     }),

    //     addTeacher: build.mutation({
    //       query: (data) => ({
    //         url: `/teachers`,
    //         method: "POST",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["OHSApi"],
    //     }),

    //     deleteTeacher: build.mutation({
    //       query: (id) => ({
    //         url: `/teachers/${id}`,
    //         method: "DELETE",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       invalidatesTags: ["OHSApi"],
    //     }),
  }),
});

export const { useGetAllOhsCountsMutation } = OHSApi;
